// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".notification-empty-wrapper[data-v-14eb9248]{align-items:center;box-sizing:border-box;display:flex;flex-direction:column;gap:.04rem;height:100%;justify-content:center;padding:.16rem;width:100%}.notification-empty-wrapper .icon-empty[data-v-14eb9248]{height:.76rem;width:.76rem}.notification-empty-wrapper .empty-text[data-v-14eb9248]{color:#000;font-family:\"PP Right Grotesk\",sans-serif;font-size:.22rem;font-weight:900;line-height:.28rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
